<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->

        <div class="text-center">
          <img src="/assets/images/logo-md.png" alt="logo.png">
        </div>
        <div class="auth-box card">
          <div class="card-block">
            <router-outlet></router-outlet>
          </div>
        </div>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
